import React, {Component} from 'react';
import Alert from '../common/Alert';

import api from '../../config/api';
import shopImage1 from '../../media/shop-image-1.jpg';
import shopImage2 from '../../media/shop-image-2.jpg';
import LandingFrom from "../form/LandingFrom";

class SmartHomeWorkshopPage extends Component {

	constructor() {
		super();
		this.state = {
			name: '',
			email: '',
			phone: '',
			alertMessage: '',
			alertType: '',
			alertRendered: false,
			contactButtonDisabled: false
		};
	}

	setContactButtonState = (state) => {
		this.setState({
			contactButtonDisabled: state
		});
	};

	setForm = (name, value) => {
		this.setState({
			[name]: value
		});
	};

	sendForm = () => {

		if (this.state.name.length <= 0 ||
			this.state.email.length <= 0 ||
			this.state.phone.length <= 0) {
			this.setState({
				alertMessage: "A név, a telefonszám és az email kötelező mezők!",
				alertType: "FAIL",
				alertRendered: true,
				contactButtonDisabled: false,
			});
			return;
		}

		const options = {
			method: 'POST',
			body: JSON.stringify({
				name: this.state.name,
				email: this.state.email,
				phone: this.state.phone
			}),
			headers: new Headers({
				'Content-Type': 'application/json'
			})
		};

		fetch(api.landing('SMARTHOME_WORKSHOP'), options)
			.then(res => res.json())
			.then(data => this.setState({
				name: data.status.includes('FAIL')? this.state.name : '',
				phone: data.status.includes('FAIL')? this.state.phone : '',
				email: data.status.includes('FAIL')? this.state.email : '',
				alertMessage: data.text,
				alertType: data.status,
				alertRendered: true,
				contactButtonDisabled: false,
			}))
			.catch(err => {
				console.log(err);
				this.setState({
					alertMessage: 'Valami hiba történt, próbálja meg később!',
					alertType: 'FAIL',
					alertRendered: true,
					contactButtonDisabled: false
				})
			});
	};

	render() {

		const { alertType, alertMessage, alertRendered, contactButtonDisabled, email, name, phone} = this.state;

		return (
			<div className="container-flex">
				<div className="page__banner page__banner--smarthome-workshop">
				</div>
				<div className="page page--landing page--smarthome-workshop">
					<section className="landing-info">
						<h2 className="color-red">2019. november 14. (csütörtök) <br/> Kényelem és biztonság otthon, logikai kapcsolatok által – AMIKO HOME Okos otthon workshop</h2>
						<h3 className="color-blue">2142 Nagytarcsa, Ganz Ábrahám utca 5. I. emeleti tárgyaló</h3>
					</section>
					<section className="landing-program">
						<div className="landing-program__dates">
							<h3 className="color-blue">Program:</h3>
							<ul>
								<li>9:00</li>
								<li>Kezdés - cégbemutatkozó</li>
								<li>9:15-10:15</li>
								<li>AMIKO HOME (Zigbee) okos otthon eszközök bemutatása és konfigurálása</li>
								<li>10:15-10:30</li>
								<li>Szünet (Szendvics, kávé stb.)</li>
								<li>10:30-11:30</li>
								<li>Logikai kapcsolatok, logikával létrehozható funkciók bemutatása</li>
								<li>11:30-11:45</li>
								<li>Értékesítés támogatás (árak, elérhető kedvezmények)</li>
								<li>11:45-12:00</li>
								<li>Kérdés-válasz szekció</li>
								<li>12:00</li>
								<li>Rendezvény vége</li>
							</ul>
							<div className="embed-responsive embed-responsive-16by9">
								<iframe className="embed-responsive-item"
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2694.892958152783!2d19.28439021599246!3d47.51147580253699!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741c68fab61ea47%3A0xca9b5deb6730a316!2sNagytarcsa%2C%20Ganz%20%C3%81brah%C3%A1m%20utca%205%2C%202142!5e0!3m2!1shu!2shu!4v1572514861493!5m2!1shu!2shu"
									frameBorder="0" style={{border:0}} allowFullScreen></iframe>
							</div>
						</div>
						<div className="landing-program__images">
							<img className="img-responsive" src={shopImage1} alt="AMIKO HOME Márkabolt"/>
							<img className="img-responsive" src={shopImage2} alt="AMIKO HOME Márkabolt"/>
						</div>
					</section>
					<section className="landing-form">
						<h3>Részvételi szándékát kérjük az alábbi űrlap kitöltésével jelezze.</h3>
						<Alert alertType={alertType}
						       alertMessage={alertMessage}
						       rendered={alertRendered} />
						<LandingFrom setForm={this.setForm}
						             sendForm={this.sendForm}
						             contactButtonDisabled={contactButtonDisabled}
						             setContactButtonState={this.setContactButtonState}
						             name={name} email={email} phone={phone}/>
					</section>
					<section className="landing-info">
						<h2>Várjuk Önt is sok szeretettel!</h2>
						<h3>- AMIKO HOME</h3>
					</section>
				</div>
			</div>
		);
	}
}

export default SmartHomeWorkshopPage;


// WEBPACK FOOTER //
// ./src/components/landing/SmartHomeWorkshopPage.js